// extracted by mini-css-extract-plugin
export default {"menuHeight":"72px","menu-down":"dropdown-icon_menu-down__sIgQ5"};